import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { HTMLAttributes } from 'react';
import { JoveLogo, LogoLight } from '@jove-frontend/uikit';
import clsx from 'clsx';
import HarveyNashLogo from '../../assets/Whitelabel/Harvey-Nash-Logo.png';
import { ReactComponent as WamoLogoLight } from '../../assets/Whitelabel/wamo-logo-light.svg';
import { ReactComponent as WamoLogo } from '../../assets/Whitelabel/wamo-logo.svg';
import { ReactComponent as PoweredByJoveLogoLight } from '../../assets/poweredby-jove-light.svg';
import { ReactComponent as PoweredByJoveLogo } from '../../assets/poweredby-jove.svg';
import { ReactComponent as LogoDeel } from '../../assets/recruiter-page/deel-logo.svg';
import { useOrganizationLandingPageStore } from '../../store/OrganizationLandingPageStore';

const PoweredByJove = () => {
  return (
    <>
      <PoweredByJoveLogoLight className="block lg:hidden" />
      <PoweredByJoveLogo className="hidden lg:block" />
    </>
  );
};

type LogoProps = HTMLAttributes<HTMLDivElement> & {
  organizationSlug?: string;
  orgLogoClassName?: string;
};
export const Logo = (props: LogoProps): React.ReactElement => {
  const { organizationSlug, className, orgLogoClassName } = props;
  const router = useRouter();
  const { organization } = useOrganizationLandingPageStore(
    ({ state }) => state
  );

  const isWamo = router.asPath.includes('/wamo');
  const isDeel = router.asPath.includes('/deel');

  if (isWamo) {
    return (
      <div className="flex flex-col items-center space-x-0 space-y-2 ">
        <div className="w-48">
          <span className="block lg:hidden">
            <WamoLogo />
          </span>

          <span className="hidden lg:block">
            <WamoLogoLight />
          </span>
        </div>
        <PoweredByJove />
      </div>
    );
  }

  if (isDeel) {
    return (
      <div className="flex items-center space-x-2 sm:flex-col sm:space-x-0 sm:space-y-2">
        <div>
          <span className="hidden lg:block">
            <LogoDeel />
          </span>

          <span className="block lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="69"
              height="24"
              viewBox="0 0 69 24"
              fill="none"
            >
              <path
                d="M56.1328 23.5331C56.0322 23.5331 55.9507 23.4515 55.9507 23.3509V1.41044C55.9507 1.32406 56.0114 1.24957 56.0959 1.23208L59.9279 0.439811C60.0409 0.416443 60.1469 0.502754 60.1469 0.618169V23.3509C60.1469 23.4515 60.0654 23.5331 59.9648 23.5331H56.1328Z"
                fill="white"
              />
              <path
                d="M7.99907 23.9972C6.46919 23.9972 5.10323 23.6257 3.90118 22.8826C2.69914 22.1395 1.74843 21.1232 1.04906 19.8337C0.349686 18.5443 0 17.08 0 15.4408C0 13.8017 0.349686 12.3483 1.04906 11.0807C1.74843 9.79121 2.69914 8.78586 3.90118 8.06463C5.10323 7.32155 6.46919 6.95001 7.99907 6.95001C9.22297 6.95001 10.2939 7.17949 11.2118 7.63845C11.9491 8.00709 12.5736 8.49557 13.0852 9.10389C13.2005 9.24093 13.4411 9.163 13.4411 8.98393V1.0159C13.4411 0.92953 13.5017 0.855035 13.5863 0.837547L17.4183 0.0452799C17.5313 0.021912 17.6373 0.108223 17.6373 0.223638V23.4217C17.6373 23.5223 17.5557 23.6038 17.4552 23.6038H14.0497C13.9627 23.6038 13.8879 23.5423 13.871 23.4569L13.5217 21.6854C13.491 21.5294 13.2865 21.483 13.1847 21.6051C12.6957 22.1917 12.0817 22.7159 11.3429 23.1776C10.4906 23.724 9.37595 23.9972 7.99907 23.9972ZM8.88421 20.3255C10.2392 20.3255 11.3429 19.8775 12.1953 18.9814C13.0695 18.0635 13.5066 16.8942 13.5066 15.4736C13.5066 14.053 13.0695 12.8947 12.1953 11.9986C11.3429 11.0807 10.2392 10.6217 8.88421 10.6217C7.55103 10.6217 6.44733 11.0697 5.57312 11.9658C4.6989 12.8619 4.2618 14.0202 4.2618 15.4408C4.2618 16.8614 4.6989 18.0307 5.57312 18.9486C6.44733 19.8665 7.55103 20.3255 8.88421 20.3255Z"
                fill="white"
              />
              <path
                d="M27.8696 23.9998C26.2304 23.9998 24.777 23.6501 23.5094 22.9508C22.2418 22.2514 21.2474 21.2679 20.5262 20.0003C19.8049 18.7327 19.4443 17.2684 19.4443 15.6074C19.4443 13.9245 19.794 12.4274 20.4934 11.1161C21.2146 9.80476 22.1981 8.78849 23.4439 8.06726C24.7115 7.32418 26.1976 6.95264 27.9024 6.95264C29.4978 6.95264 30.9075 7.30232 32.1314 8.0017C33.3553 8.70107 34.306 9.6627 34.9835 10.8866C35.6829 12.0886 36.0326 13.4328 36.0326 14.9189C36.0326 15.1593 36.0216 15.4107 35.9998 15.6729C35.9998 15.883 35.9928 16.1001 35.9787 16.3243C35.9728 16.4192 35.8935 16.4925 35.7983 16.4925H23.8029C23.6974 16.4925 23.6137 16.5821 23.6242 16.6871C23.7414 17.8623 24.173 18.7919 24.9191 19.4758C25.7278 20.197 26.7003 20.5576 27.8368 20.5576C28.6892 20.5576 29.3995 20.3718 29.9677 20.0003C30.5238 19.6296 30.944 19.1618 31.2284 18.5969C31.2603 18.5336 31.3244 18.4923 31.3953 18.4923H35.2965C35.4184 18.4923 35.5058 18.6096 35.4674 18.7253C35.1555 19.662 34.6664 20.5241 34 21.3116C33.3006 22.1421 32.4264 22.7978 31.3774 23.2786C30.3502 23.7594 29.1809 23.9998 27.8696 23.9998ZM27.9024 10.3621C26.8752 10.3621 25.9682 10.6571 25.1814 11.2472C24.443 11.7805 23.9549 12.5831 23.717 13.6553C23.6923 13.7665 23.7784 13.8699 23.8923 13.8699H31.5771C31.6821 13.8699 31.7657 13.7813 31.7552 13.6769C31.6561 12.6961 31.2679 11.908 30.5906 11.3128C29.8693 10.679 28.9733 10.3621 27.9024 10.3621Z"
                fill="white"
              />
              <path
                d="M46.124 23.9998C44.4848 23.9998 43.0314 23.6501 41.7638 22.9508C40.4962 22.2514 39.5018 21.2679 38.7806 20.0003C38.0593 18.7327 37.6987 17.2684 37.6987 15.6074C37.6987 13.9245 38.0484 12.4274 38.7478 11.1161C39.469 9.80476 40.4525 8.78849 41.6983 8.06726C42.9659 7.32418 44.452 6.95264 46.1568 6.95264C47.7522 6.95264 49.1619 7.30232 50.3858 8.0017C51.6097 8.70107 52.5604 9.6627 53.2379 10.8866C53.9373 12.0886 54.287 13.4328 54.287 14.9189C54.287 15.1593 54.276 15.4107 54.2542 15.6729C54.2542 15.883 54.2472 16.1001 54.2331 16.3243C54.2272 16.4192 54.1479 16.4925 54.0527 16.4925H42.0573C41.9518 16.4925 41.8681 16.5821 41.8786 16.6871C41.9958 17.8623 42.4274 18.7919 43.1735 19.4758C43.9822 20.197 44.9547 20.5576 46.0912 20.5576C46.9436 20.5576 47.6539 20.3718 48.2221 20.0003C48.7782 19.6296 49.1984 19.1618 49.4828 18.5969C49.5147 18.5336 49.5788 18.4923 49.6497 18.4923H53.5509C53.6728 18.4923 53.7602 18.6096 53.7217 18.7253C53.4099 19.662 52.9207 20.5241 52.2544 21.3116C51.555 22.1421 50.6808 22.7978 49.6318 23.2786C48.6046 23.7594 47.4353 23.9998 46.124 23.9998ZM46.1568 10.3621C45.1296 10.3621 44.2226 10.6571 43.4358 11.2472C42.6974 11.7805 42.2093 12.5831 41.9714 13.6553C41.9467 13.7665 42.0328 13.8699 42.1467 13.8699H49.8315C49.9365 13.8699 50.0201 13.7813 50.0096 13.6769C49.9105 12.6961 49.5223 11.908 48.845 11.3128C48.1237 10.679 47.2277 10.3621 46.1568 10.3621Z"
                fill="white"
              />
              <circle cx="65.6457" cy="20.7128" r="2.82512" fill="white" />
            </svg>
          </span>
        </div>
        <PoweredByJove />
      </div>
    );
  }

  if (!organizationSlug) {
    return (
      <>
        <JoveLogo className="hidden h-[38px] w-full min-w-[60px] lg:block xl:min-w-[80px]" />
        <LogoLight className="-ml-4 block h-8 lg:hidden" />
      </>
    );
  }

  if (organizationSlug === 'harvey-nash') {
    return (
      <div className="flex flex-row items-center space-x-4 space-y-0">
        <Image src={HarveyNashLogo} alt="Harvey Nash" />
        <PoweredByJove />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'flex',
        className?.includes('flex-row')
          ? className
          : 'flex-col items-center justify-center space-x-0 space-y-2'
      )}
    >
      {organization?.logo?.url && (
        <img
          src={organization?.logo?.url}
          alt="logo"
          className={clsx(orgLogoClassName || 'w-[150px] md:h-10 md:w-auto')}
        />
      )}

      <PoweredByJove />
    </div>
  );
};
